<template>
  <div class="root">
    <c-header></c-header>
    <div class="index-bg">
      <div class="index-logo">
        <img src="./images/index-logo.png" alt="图片加载失败">
      </div>
      <div class="index-content">
        <div class="copywriting">
          <ul class="title">
            <li class="left-line"></li>
            <li class="text">正规持牌机构</li>
            <li class="right-line"></li>
          </ul>
          <p>致力于更多小微企业</p>
          <p>提供数字普惠金融服务</p>
          <ul class="scene">
            <li class="left">现金分期</li>
            <li class="middle">场景分期</li>
            <li class="right">小额贷款</li>
          </ul>
          <div class="note">
            <p>贷款有风险，借款需谨慎</p>
            <p>请根据个人能力合理贷款，合法理性消费</p>
            <p>杜绝借款犯罪，倡导合龄合法借贷</p>
            <p>信守借款合约，避免逾期</p>
          </div>
        </div>
        <!-- 采集信息模块入口-屏蔽-20200715 -->
        <!-- <div class="consult">
          <div class="title">小微企业贷款</div>
          <ul class="table">
            <li><input class="amount" type="text" name="amount" placeholder="请输入申请金额" v-model="amount"/></li>
            <li><input class="phone" type="text" name="phone" placeholder="请输入您的电话号码" v-model="phone" /></li>
            <li v-show="showVcode" class="vcode-box">
              <input class="vcode" type="text" name="vcode" placeholder="请输入验证码" v-model="vcode" />
              <img class="img-code" @click="refreshCode" :src="imgCode" alt="点击重载">
            </li>
            <li class="statement"><p>我们承诺:以上个人信息将严格保密</p></li>
            <li class="agreement">
              <i><input class="protocal" type="checkbox" name="protocal" @change="change" v-model="isChecked" id="protocal"></i>
              <label class="protocalBox" for="protocal">我已阅读并同意
                <strong>
                  <a :href="'https://rule.zbj.com/ruleshow-0?pid='+serviceId" target="_blank" class="form-protocal">服务协议</a>、
                  <a :href="'https://rule.zbj.com/ruleshow-0?pid='+tradeId" target="_blank" class="form-protocal">网络服务交易协议</a>、
                  <a :href="'https://rule.zbj.com/ruleshow-0?pid='+secertId" target="_blank" class="form-protocal">隐私保护政策</a>
                </strong>
              </label>
            </li>
            <li class="submit">
              <button type="button" @click="nextStep" class="next-step">立即免费申请</button>
            </li>
          </ul>
        </div> -->
      </div>
    </div>

    <el-dialog
      title="申请表"
      :center="true"
      :visible.sync="showApplyInfo"
      width="40%">
      <div class="apply-table">
        <el-form ref="form" :model="form" label-width="80px" v-loading="showLoading">
          <el-form-item label="您的身份">
            <el-select v-model="form.userIdentity" placeholder="请选择身份"  style="width:100%">
              <el-option v-for="item in userIdentityList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="您的姓名">
            <el-input v-model="form.userName"  placeholder="请输入您的真实姓名"></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input v-model="form.userNo"  placeholder="请输入身份证号"></el-input>
          </el-form-item>
          <el-form-item label="房产情况">
            <el-radio-group v-model="form.userHouse">
              <el-radio v-for="item in userHouseList" :key="item.value" :label="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="车产情况">
            <el-radio-group v-model="form.userCar">
              <el-radio v-for="item in userCarList" :key="item.value" :label="item.value">{{item.label}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="所在城市">
            <el-cascader
              size="large"
              :options="areaOptions"
              v-model="selectedOptions"
              placeholder="请选择所在城市"
              @change="handleChange"
              style="width:100%">
            </el-cascader>
          </el-form-item>
          <el-form-item label="成立时间">
            <el-select v-model="form.setUpTime" placeholder="请按照营业执照发放日期选择"  style="width:100%">
              <el-option v-for="item in setUpTimeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="年营业额">
            <el-input v-model="form.annualTurnover"  placeholder="请输入年营业额">
              <span slot="suffix">万</span>
            </el-input>
          </el-form-item>
          <el-form-item label="员工人数">
            <el-select v-model="form.userScale" placeholder="请选择当前员工人数"  style="width:100%">
              <el-option v-for="item in userScaleList" :key="item.value" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="showSubmitCode" class="vcode-box" label="验证码">
              <el-input class="vcode" type="text" name="vcode" placeholder="请输入验证码" v-model="submitCode" style="width:50%;"></el-input>
              <div style="position:absolute;left:55%;top:0;height:40px;background-color:rgba(0,0,0,0.2);border-radius:3px;">
                <img @click="getSubmitCode" :src="imgSubmitCode" alt="点击重载" style="height:100%;" />
              </div>
          </el-form-item>
          <div class="submit-form" @click="applySubmit">提交申请</div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import $ from 'jquery'
  import { regionData } from 'element-china-area-data'
  import CHeader from 'components/c-header/index.vue';
  export default {
    name: 'info',
    data () {
      return {
        amount: '',
        phone: '',
        vcode: '',
        imgCode: '',
        submitCode: '',
        imgSubmitCode: '',
        showSubmitCode: false,
        isChecked: false,
        isVerify: false,
        showVcode: false,
        showApplyInfo: false,
        showLoading: false,
        form: {
          userIdentity: '',
          userName: '',
          userNo: '',
          userHouse: '',
          userCar: '',
          setUpTime: '',
          annualTurnover: '',
          userScale: '',
          province: '', // 所在省
          city: '', // 所在城市
          district: '', // 所在区县
          phoneNo: '0',
          expectedAmount: '0',
          mortgage: '0',
          userIndustry: '',
          referrer: 'jrmh', // 暂时用于标记数据来源
        },
        userHouseList: [
          {label: '全款房', value: '1'},
          {label: '按揭房', value: '2'},
          {label: '无房', value: '3'},
        ],
        userCarList: [
          {label: '全款车', value: '1'},
          {label: '按揭车', value: '2'},
          {label: '无车', value: '3'},
        ],
        userIdentityList: [
          {label: '企业法人/股东', value: '1'},
          {label: '个体工商户', value: '2'},
          {label: '其他', value: '3'},
        ],
        userScaleList: [
          {label: '10人以下', value: '1'},
          {label: '10-29人', value: '2'},
          {label: '30-39人', value: '3'},
          {label: '50-99人', value: '4'},
          {label: '100-199人', value: '5'},
          {label: '200-499人', value: '6'},
          {label: '500人及以上', value: '7'},
        ],
        setUpTimeList: [
          {label: '半年以内', value: '1'},
          {label: '半年至一年', value: '2'},
          {label: '一年至两年', value: '3'},
          {label: '两年至五年', value: '4'},
          {label: '五年以上', value: '5'},
        ],
        areaData: [],
        areaOptions: regionData,
        selectedOptions: [],
        provinceList: [],
        cityList: [],
        areaList: [],
        secertId: '',
        serviceId: '',
        tradeId: '',
        voucher: '01010101*10101010', // 用于存储与node层接口调用的通讯凭据
      }
    },
    components: {
      CHeader
    },
    mounted () {
      this.$bus.$emit('ready');
      // this.getArea();
      this.secertId = window.ZBJInfo.secertId;
      this.serviceId = window.ZBJInfo.serviceId;
      this.tradeId = window.ZBJInfo.tradeId;
      this.voucher = window.ZBJInfo.voucher; // 获取配置中心配置的凭据
    },
    methods: {
      change() {
      },
      getImgCode (phone) {
        this.imgCode = '/captcha?phone=' + phone + '&_=' + Date.now();
      },
      getSubmitCode () {
        this.imgSubmitCode = '/captcha?phone=' + this.voucher + '&_=' + Date.now();
      },
      verifyCode () {
        if (!/[0-9]+/.test(this.amount)) {
          this.$message({
              message: '申请金额格式有误！',
              type: 'error',
              offset: 300
            });
          return;
        }
        if (!$.trim(this.phone)) {
          this.$message({
              message: '手机号必须填写！',
              type: 'error',
              offset: 300
            });
          return;
        }
        if (!this.phone.match(/1[3|4|5|6|7|8|9]\d{9}/)) {
          this.$message({
              message: '手机号格式有误！',
              type: 'error',
              offset: 300
            });
          return;
        }
        if (this.showVcode) {
          if (!$.trim(this.vcode)) {
            this.$message({
              message: '图形验证码不能为空！',
              type: 'error',
              offset: 300
            });
            return;
          }
        }
        if (!this.isChecked) {
          this.$message({
              message: '请先阅读并勾选服相关协议',
              type: 'error',
              offset: 300
            });
          return
        }
        return true;
      },
      nextStep() {
        if (!this.verifyCode()) {
          return;
        }
        this.$ajax({
          url: '/captcha/validate',
          method: 'get',
          dataType: 'json',
          params: {
            code: this.vcode,
            phone: this.phone
          }
        }).then(rs => {
          if (rs.success) {
            this.showApplyInfo = true;
            this.form.expectedAmount = this.amount;
            this.form.phoneNo = this.phone;
          } else {
            if (this.showVcode) {
              this.$message({
                message: rs.msg,
                type: 'error',
                offset: 300
              });
            } else {
              this.$message({
                message: '请输入图形验证码',
                type: 'error',
                offset: 300
              });
              this.showVcode = true;
              this.imgCode = '/captcha?phone=' + this.phone + '&_=' + Date.now();
            }
            this.refreshCode();
          }
        })
      },

      refreshCode () {
        if (!$.trim(this.phone)) {
            this.$message({
              message: '手机号必须填写！',
              type: 'error',
              offset: 300
            });
          return;
        }
        if (!this.phone.match(/1[3|4|5|6|7|8|9]\d{9}/)) {
          this.$message({
              message: '手机号格式有误！',
              type: 'error',
              offset: 300
            });
          return;
        }
        this.imgCode = '/captcha?phone=' + this.phone + '&_=' + Date.now();
      },

      applySubmit () {
        let idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
        if (!this.form.userIdentity) {
          this.$message({
            message: '请选择您的身份！',
            type: 'error',
            offset: 300
          });
          return;
        }
        if (!this.form.userName) {
          this.$message({
            message: '请填写您的真实姓名！',
            type: 'error',
            offset: 300
          });
          return;
        }
        if (!$.trim(this.form.userNo)) {
          this.$message({
            message: '请填写您的身份证号！',
            type: 'error',
            offset: 300
          });
          return;
        }
        if (!idcardReg.test(this.form.userNo)) {
          this.$message({
            message: '请确认身份证号填写正确！',
            type: 'error',
            offset: 300
          });
          return;
        }
        if (!this.form.userHouse) {
          this.$message({
            message: '请选择您的房产情况！',
            type: 'error',
            offset: 300
          });
          return;
        }
        if (!this.form.userCar) {
          this.$message({
            message: '请选择您的车产情况！',
            type: 'error',
            offset: 300
          });
          return;
        }
        if (!this.form.province) {
          this.$message({
            message: '请选择您的所在城市！',
            type: 'error',
            offset: 300
          });
          return;
        }
        if (!this.form.setUpTime) {
          this.$message({
            message: '请选择公司成立时间！',
            type: 'error',
            offset: 300
          });
          return;
        }
        if (!this.form.annualTurnover || Number.isNaN(Number.parseFloat(this.form.annualTurnover))) {
          this.$message({
            message: '请填写公司年营业额(必须填写数字)！',
            type: 'error',
            offset: 300
          });
          return;
        }
        if (!this.form.userScale) {
          this.$message({
            message: '请选择公司员工人数！',
            type: 'error',
            offset: 300
          });
          return;
        }
        this.showSubmitCode = true;
        if (this.showSubmitCode) {
          if (!$.trim(this.submitCode)) {
            this.$message({
              message: '提交表单的验证码不能为空！',
              type: 'error',
              offset: 300
            });
            this.getSubmitCode();
            return;
          }
        }
        this.form.submitCode = this.submitCode;
        this.$ajax({
          url: '/api/submitForm',
          data: this.form,
          method: 'post',
          directAjax: true,
        }).then(rs => {
          setTimeout(() => {
            this.showLoading = false;
            }, 1500);
          if (rs.success) {
            this.$message({
              message: '信息提交成功！',
              type: 'success',
              offset: 300
            });
            this.showApplyInfo = false;
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          } else {
            if(rs.data.errorCode && rs.data.errorCode === '500'){
              this.getSubmitCode();
              this.$message({
                message: '验证码错误，请重新输入！',
                type: 'error',
                offset: 300
              });
            }else{
              this.$message({
                message: '网络异常，请稍后重试！',
                type: 'error',
                offset: 300
              });
              setTimeout(() => {
                window.location.reload();
              }, 1500);
            }
          }
        })
      },

      getArea () {
        this.$ajax({
          url: '/api/queryArea',
          type: 'GET',
        }).then(rs => {
          if (rs.success) {
            this.provinceList = rs.provinceList;
            this.cityList = rs.cityList;
            this.areaList = rs.areaList;
          } else {
          }
        })
      },
      handleChange () {
        let province = '';
        let city = '';
        let area = '';
        if (this.selectedOptions[0]) {
          this.provinceList.forEach(item => {
            if (item.areaCode === this.selectedOptions[0]) {
              province = item.areaName;
            }
          })
        }
        if (this.selectedOptions[1]) {
          this.cityList.forEach(item => {
            if (item.areaCode === this.selectedOptions[1]) {
              city = item.areaName;
            }
          })
        }
        if (this.selectedOptions[2]) {
          this.areaList.forEach(item => {
            if (item.areaCode === this.selectedOptions[2]) {
              area = item.areaName;
            }
          })
        }
        console.log(province + '' + city + '' + area)
        this.form.province = province;
        this.form.city = city;
        this.form.district = area;
      },
    }
  }
</script>

<style scoped rel="stylesheet/less" lang="less">
@import "..\..\..\global\css\mixin\mixin.less";
  .root {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .apply-table{
    width: 80%;
    margin: 0 auto;
  }
  .index-bg{
    position: relative;
    width: 100%;
    height:100%;
    background: url('./images/index-bg.png') no-repeat center top;
    .index-logo{
      position: absolute;
      width: 100px;
      height: 60px;
      left: 66px;
      bottom:40px;
      img{
        width: 100%;
      }
    }
    .index-content{
      position: absolute;
      width: 1200px;
      left:50%;
      margin-left:-600px;
      top:260px;
      min-height: 380px;
      .copywriting{
        // position: absolute;
        margin: 0 auto;
        width: 678px;
        height: 380px;
        // top:0px;
        // left:0px;
        p{
            height:90px;
            line-height: 90px;
            font-size: 56px;
            color: #f2f2f2;
            letter-spacing: 10px;
          }
        .title{
          width:678px;
          height:56px;
          li{
            float: left;
            height: 56px;
            line-height: 56px;
            &.left-line,&.right-line{
              width: 245px;
            }
            &.text{
              width: 188px;
              text-align: center;
              color:#dedede;
              font-size: 22px;
              letter-spacing: 5px;
            }
            &.left-line{
              background: url('./images/stripe-left.png') no-repeat center;
            }
            &.right-line{
              background: url('./images/stripe-right.png') no-repeat center;
            }
          }
        }
        .scene{
          width: 100%;
          height: 40px;
          padding-top:50px;
          li{
            float: left;
            width: 135px;
            height: 40px;
            line-height: 40px;
            color: #dedede;
            font-size: 18px;
            text-align: center;
            &.left{
              text-align: left;
              background: url('./images/vertical-line-index.png') no-repeat right center;
            }
            &.right{
              text-align: right;
              background: url('./images/vertical-line-index.png') no-repeat left center;
            }
          }
        }

        .note{
          width: 100%;
          height: 40px;
          padding-top:180px;
          p{
            color: #999;
            font-size: 14px;
            height: 24px;
          }
        }

      }
      .consult{
        position: absolute;
        width: 382px;
        min-height: 386px;
        right: 0px;
        top: 0px;
        background-color: #ffffff;
        border-radius: 10px;
        .title{
          color: #ff6900;
          height: 60px;
          line-height: 60px;
          border-bottom: 1px solid #f4f4f4;
          padding-left:40px;
          font-size: 16px;
        }
        .table{
          padding:20px 40px 20px 40px;
          input{
            outline: none;
            padding-left: 40px;
          }
          .amount{
            width: 266px;
            height: 42px;
            border: 1px solid #ccc;
            border-radius: 5px;
            background: url('./images/icon-money.png') no-repeat left 10px center;
            margin-bottom: 20px;
          }
          .phone{
            width: 266px;
            height: 42px;
            border: 1px solid #ccc;
            border-radius: 5px;
            background: url('./images/icon-phone.png') no-repeat left 10px center;
            margin-bottom: 20px;
          }
          .vcode{
            width: 146px;
            height: 42px;
            border: 1px solid #ccc;
            border-radius: 5px;
            background: url('./images/icon-code.png') no-repeat left 10px center;
            float: left;
          }
          .vcode-box{
            width: 100%;
            height: 42px;
            margin-bottom: 20px;
            .img-code{
              width: 80px;
              height: 34px;
              padding: 5px;
              float: right;
              border:1px solid #f4f4f4;
              border-radius: 4px;
              background-color: #f4f4f4
            }
          }
          .agreement{
            line-height: 25px;
            font-size: 14px;
            .protocal{
              margin:0;
              margin-right:5px;
            }
            .protocalBox{
              a{
                text-decoration: underline;
              }
            }
          }
          .statement{
            p{
              line-height: 30px;
              font-size: 12px;
              height: 30px;
            }
          }
          .submit{
            padding:10px 0;
            .next-step{
              width: 309px;
              height: 44px;
              border: none;
              border-radius: 5px;
              background-color: #ff6900;
              color: #ffffff;
              font-size: 16px;
              text-align: center;
              line-height: 44px;
              outline: none;
            }
          }
        }
      }
    }
  }
  .submit-form{
    width: 100%;
    height: 50px;
    line-height: 50px;
    border-radius: 5px;
    color: #fff;
    background-color: #ff6900;
    text-align: center;
    font-size: 16px;
    cursor: pointer;
  }
  .layer-container{
    z-index: 999999;
  }
</style>



// WEBPACK FOOTER //
// index.vue?9f15faf8